import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';

const ParagraphNewsAll = ({ paragraphKey }) => {
  const viewId = 'news';
  const display = 'block_2';
  // eslint-disable-next-line no-unused-vars
  const [currentFilters, setCurrentFilters] = useState({});

  return (
    <div id={paragraphKey}>
      <Fade triggerOnce bottom distance="50px" duration={500}>
        <View id={viewId} display={display} filters={currentFilters} />
      </Fade>
    </div>
  );
};

export default ParagraphNewsAll;
